export enum EnvironmentTypes {
    LOCAL = 'local',
    DEV = 'dev',
    TST = 'tst',
    UAT = 'uat',
    SUP = 'sup',
    PROD = 'prd',
}
